import { Component, Mixins } from 'vue-property-decorator';
import { AppHypotheekMixin } from '../mixins/AppHypotheekMixin';
import { State } from 'vuex-class';
import AppUploadDocumentenVue from '@/components/upload-documenten/AppUploadDocumenten.vue';

@Component({
  components: {
    'app-upload-documenten': AppUploadDocumentenVue
  }
})
export default class AppBouwdepot extends Mixins(AppHypotheekMixin) {
  @State(state => state.config.ppfDeclaratieBouwdepotUrl)
  public ppfDeclaratieBouwdepotUrl!: string;

  public get uploadUrl(): string {
    return `Formulieren/Declaratie/${this.hypotheeknummer}`;
  }

  public uploadSucceeded() {
    this.$log.debug('');
    this.$router.push({ name: 'hypotheek', params: { uploadBouwdepotSucceeded: 'true' } });
  }
}
